module.exports = __webpack_public_path__ + "img/4572e1a.png";